// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__Cf2TY","text":"SelectPayment_text__26E0C","title":"SelectPayment_title__3ZRdH","btn":"SelectPayment_btn__1WXzs"};